import { ActionLabels } from '@sbv-clients/util-misc';

import {
  Button,
  Dialog,
  DialogActionsContainer,
  DialogContent,
  DialogHeader,
  ConfirmDialogButtons,
  DialogMessage,
  smallDialogBodySx,
  smallDialogSx,
  useRedesignDialogs,
  printErrorToConsole,
  useToggleModal,
} from '../../index';

export const useConfirmModal = (
  handleConfirm: () => void,
  title: string,
  content: string
) => {
  const redesign = useRedesignDialogs();
  const { open, openModal, closeModal } = useToggleModal();

  const handleConfirmWithClose = () => {
    try {
      closeModal();
      handleConfirm();
    } catch (e) {
      printErrorToConsole(e);
    }
  };

  const modal = () => {
    if (redesign) {
      const danger = /delete|remove/i.test(`${title} ${content}`);
      return (
        <Dialog open={open} fullWidth sx={smallDialogSx}>
          <DialogHeader title={title} onClose={closeModal} />
          <DialogContent sx={smallDialogBodySx}>
            <DialogMessage tone={danger ? 'danger' : 'warn'}>
              {content}
            </DialogMessage>
          </DialogContent>
          <DialogActionsContainer>
            <ConfirmDialogButtons
              cancelLabel={ActionLabels.Cancel}
              confirmLabel={danger ? 'Delete' : ActionLabels.Confirm}
              danger={danger}
              onCancel={closeModal}
              onConfirm={handleConfirmWithClose}
            />
          </DialogActionsContainer>
        </Dialog>
      );
    }
    return (
      <Dialog open={open} fullWidth>
        <DialogHeader title={title} onClose={closeModal} />
        <DialogContent sx={{ mt: 6 }}>{content}</DialogContent>
        <DialogActionsContainer>
          <Button variant="outlined" onClick={closeModal}>
            {ActionLabels.Cancel}
          </Button>
          <Button variant="contained" onClick={handleConfirmWithClose}>
            {ActionLabels.Confirm}
          </Button>
        </DialogActionsContainer>
      </Dialog>
    );
  };

  return {
    modal,
    openModal,
  };
};
